/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentParcelViewModel } from "../types/IndividualPaymentParcelViewModel.ts";

export const individualPaymentParcelViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  numberParcel: z.optional(z.number().int()),
  total: z.optional(z.number()),
  totalPaid: z.number().nullish(),
  expirationDate: z.optional(z.string().datetime()),
  paymentDate: z.string().datetime().nullish(),
  paymentType: z.optional(z.number().int()),
  serial: z.number().int().nullish(),
  valueWithFine: z.number().nullish(),
  parcelWithDiscount: z.optional(z.number()),
  discountPunctualPercentage: z.number().nullish(),
  statusId: z.optional(z.number().int()),
  status: z.optional(z.number().int()),
  statusText: z.string().nullish(),
  paymentMethod: z.optional(z.number().int()),
  observation: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  preventFuturePayment: z.boolean().nullish(),
  paymentFuture: z.optional(z.boolean()),
  futurePaymentDate: z.string().datetime().nullish(),
  installmentAmount: z.number().nullish(),
  refundDate: z.string().datetime().nullish(),
  refundValue: z.number().nullish(),
  linkNfeCityHall: z.string().nullish(),
  hasIntegrationFealq: z.optional(z.boolean()),
  hasIntegrationVanzolini: z.optional(z.boolean()),
  hasIntegrationFusp: z.optional(z.boolean()),
  hasExcedentBilletVanzolini: z.optional(z.boolean()),
  mustRegister: z.optional(z.number().int()),
  hasBilletGenerated: z.optional(z.number().int()),
  forceCreditCardPecegePay: z.optional(z.number().int()),
  forceBilletPecegePay: z.optional(z.number().int()),
  fealqIntegrated: z.optional(z.boolean()),
  transferType: z.string().nullish(),
  hasTransactionNumber: z.optional(z.boolean()),
  isInstallment: z.optional(z.boolean()),
  planTypeText: z.string().nullish(),
  reEnrollmentParcel: z.optional(z.boolean()),
}) as unknown as ToZod<IndividualPaymentParcelViewModel>;
